var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline02Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 516.431,
    viewBox: "0 0 330 516.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timeline_02_icuida",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_37",
    "data-name": "L\\xEDnea 37",
    x1: 159,
    transform: "translate(171 334)",
    fill: "none",
    stroke: "#e2503f",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1203",
    "data-name": "Grupo 1203",
    transform: "translate(-102.246 -557)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_36",
    "data-name": "L\\xEDnea 36",
    x1: 0.254,
    y2: 275.5,
    transform: "translate(244.746 557)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1202",
    "data-name": "Grupo 1202",
    transform: "translate(0 104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1200",
    "data-name": "Grupo 1200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1198",
    "data-name": "Grupo 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1197",
    "data-name": "Grupo 1197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1196",
    "data-name": "Grupo 1196"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_189",
    "data-name": "Elipse 189",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "translate(107.049 811.838) rotate(-45)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_190",
    "data-name": "Elipse 190",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(129.932 811.838) rotate(-45)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_02.",
    "data-name": 2,
    transform: "translate(151.739 749.963)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "02."))), /*#__PURE__*/React.createElement("text", {
    id: "Sesi\\xF3n_Participativa",
    "data-name": "Sesi\\xF3n  Participativa",
    transform: "translate(176.419 797.237)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "Sesi\xF3n "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53.117
  }, "Participativa"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1199",
    "data-name": "Grupo 1199"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_77",
    "data-name": "Rect\\xE1ngulo 77",
    width: 284.937,
    height: 41.829,
    transform: "translate(102.246 927.599)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Abril_2018",
    "data-name": "Abril 2018",
    transform: "translate(188.266 954.952)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Abril 2018")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1201",
    "data-name": "Grupo 1201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_838",
    "data-name": "Trazado 838",
    d: "M265.923,756.828a13.479,13.479,0,1,0-13.479-13.478A13.478,13.478,0,0,0,265.923,756.828Z",
    fill: "none",
    stroke: "#272425",
    strokeMiterlimit: 10,
    strokeWidth: 4.357
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_839",
    "data-name": "Trazado 839",
    d: "M243.686,722.713a13.442,13.442,0,0,0-18.278,6.681A17.9,17.9,0,0,1,243.686,722.713Z",
    fill: "#fff",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.357
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_840",
    "data-name": "Trazado 840",
    d: "M224.356,736.282a13.476,13.476,0,1,0,23.4-10.49,13.408,13.408,0,0,1-5,6.7c-.285.2-.6.321-.891.494a13.477,13.477,0,0,1-16.853-2.57,13.4,13.4,0,0,0-.683,3.187c.153.006.3.039.451.045A10.467,10.467,0,0,0,224.356,736.282Z",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.357
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_841",
    "data-name": "Trazado 841",
    d: "M253.93,758h4.412c-3-6-8.536-10-14.874-10H232.032C222.516,748,214,756.939,214,766.455v13.986l.422.221,1.321.3A90,90,0,0,0,237,784.7V775A16.784,16.784,0,0,1,253.93,758Z",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_842",
    "data-name": "Trazado 842",
    d: "M231.078,730.214c.065.075.144.13.211.2.119-.347.247-.69.393-1.023C231.478,729.664,231.269,729.93,231.078,730.214Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_843",
    "data-name": "Trazado 843",
    d: "M241.867,732.987a13.621,13.621,0,0,1,.7-3.9c.14-.419.3-.832.482-1.236-.181.4-.342.817-.482,1.236a13.621,13.621,0,0,0-.7,3.9c.295-.173.606-.3.891-.494a13.408,13.408,0,0,0,5-6.7,13.5,13.5,0,0,0-4.07-3.079,17.9,17.9,0,0,0-18.278,6.681c-.146.333-.274.676-.394,1.023A13.477,13.477,0,0,0,241.867,732.987Z",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_844",
    "data-name": "Trazado 844",
    d: "M220.969,745.937a10.112,10.112,0,0,0,4.636-4.345c-.124-.223-.278-.421-.387-.657a9.916,9.916,0,0,1-.862-4.653,13.663,13.663,0,0,1-.085-1.481c0-.4.026-.8.06-1.2-.016,0-.031-.005-.048-.005a13.441,13.441,0,0,0-13.277,11.487A10.156,10.156,0,0,0,220.969,745.937Z",
    fill: "#272425",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.074
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_845",
    "data-name": "Trazado 845",
    d: "M293.081,748.279A13.478,13.478,0,1,0,279.6,734.8,13.478,13.478,0,0,0,293.081,748.279Z",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.357
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_846",
    "data-name": "Trazado 846",
    d: "M298.8,748H287.362c-6.337,0-11.873,4-14.874,10h3.336c9.515,0,16.176,7.488,16.176,17v9.715c3,.011,1.545.028,2.028.028,12.685,0,20.3-3.34,20.76-3.57l1.171-.177H316V766.455C316,756.939,308.314,748,298.8,748Z",
    fill: "none",
    stroke: "#272425",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_847",
    "data-name": "Trazado 847",
    d: "M265.491,729.871c-.172,0-.33.044-.5.051a13.428,13.428,0,0,0-12.9,12.652,10.133,10.133,0,0,0,12.08-4.709,10.151,10.151,0,0,1-1.2-3.76,10.151,10.151,0,0,0,1.2,3.76h0a10.1,10.1,0,0,0,14.6,3.494A13.442,13.442,0,0,0,265.491,729.871Z",
    fill: "#272425",
    stroke: "#272425",
    strokeMiterlimit: 10,
    strokeWidth: 3.074
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_848",
    "data-name": "Trazado 848",
    d: "M280.09,742.566c-.171,0-.33.044-.5.05a10.121,10.121,0,0,1-.436,7.286c-.109.236-.262.434-.387.657a10.1,10.1,0,0,0,14.6,3.494A13.441,13.441,0,0,0,280.09,742.566Z",
    fill: "#272425",
    stroke: "#272425",
    strokeMiterlimit: 10,
    strokeWidth: 3.074
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline02Icuida);
export default __webpack_public_path__ + "static/media/timeline_02_icuida.ae54612073dcb2a77c569e5ad71124ab.svg";
export { ForwardRef as ReactComponent };